<template lang="pug">
button.flex.w-full.items-center.justify-center.gap-2.bg-blue-600.px-5.font-bold.text-white.transition(
	type="submit"
	:disabled="loading"
	class="h-[52px] rounded-[10px] text-[15.5px] shadow-[0_1px_2px_rgba(0,0,0,0.12),0_8px_20px_rgba(37,99,235,0.22)] hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-600/20 disabled:cursor-wait disabled:opacity-80"
)
	span.h-5.w-5.animate-spin.rounded-full.border-2.border-white.border-t-transparent(v-if="loading")
	span(v-if="loading") {{ loadingLabel }}
	slot(v-else)
</template>

<script>
export default {
	props: {
		loading: Boolean,
		loadingLabel: { type: String, default: "Loading…" }
	}
}
</script>
